import { z } from 'zod';
import { PlayerColor } from '../PlayerState.ts';
import { validateState } from '../ValidateState.ts';
export const endGameResourceStateSchema = z.object({
    color: z.enum(PlayerColor),
    // Overview
    totalResourceIncome: z.number().int().nonnegative(),
    totalResourceLoss: z.number().int().nonnegative(),
    // TODO: This value can go negative because the starting distribution cards are not counted correctly.
    totalResourceScore: z.number().int(),
    // Resource Income
    rollingIncome: z.number().int().nonnegative(),
    robbingIncome: z.number().int().nonnegative(),
    devCardIncome: z.number().int().nonnegative(),
    tradeIncome: z.number().int().nonnegative(),
    // Resource Loss
    rollingLoss: z.number().int().nonnegative(),
    robbingLoss: z.number().int().nonnegative(),
    devCardLoss: z.number().int().nonnegative(),
    tradeLoss: z.number().int().nonnegative(),
    // Seafarers
    goldIncome: z.number().int().nonnegative()
}).strict();
export function validateEndGameResourceState(data) {
    return validateState(endGameResourceStateSchema, data);
}
